import { makeStyles } from "@material-ui/styles"

export default makeStyles((theme) => ({
	root: {
		display: "flex",
		alignItems: "center",
		marginRight: theme.spacing(2),
		"& .Mui-disabled": {
			color: theme.palette.grey["D100"],
			backgroundColor: theme.palette.grey["300"],
		},
	},
	button: {
		textTransform: "capitalize",
	},
	uploadButton: {
		backgroundColor: theme.palette.primary.dark,
		fontWeight: 500,
	},
	uploadForm: {
		width: 820,
	},
	dividerLine: {
		width: "100%",
		border: `1px solid ${theme.palette.grey[400]}`,
		margin: theme.spacing(1),
		marginLeft: 0,
		marginRight: 0,
	},
	row: {
		padding: `${theme.spacing(1)}px ${theme.spacing(3)}px`,
	},
	buttonWrapper: {
		display: "flex",
		justifyContent: "end",
		gap: theme.spacing(1),
	},
	btnCancel: {},
	btnUpload: {
		backgroundColor: theme.palette.primary.dark,
		fontWeight: 500,
	},
	progress: {
		color: theme.palette.grey["D100"],
	},
	title: {
		marginTop: theme.spacing(1),
	},
}))
